export default __webpack_public_path__ + "431762619450ad4c38dda4e759a7cb24.jpg";